import { gql } from '@apollo/client';

const TIPPA_REQUEST_FIELDS = 'topic multi meetingId kind combos price avoid';

export const CHAT_MESSAGE_FIELDS = `
      id
      fromTeam
      body
      createdAt
      fromTippa
      choices { label request { ${TIPPA_REQUEST_FIELDS} } }
      multi { name rationale estPrice chance outcome legs { trackName raceNumber jumpTime tabNumber horseName finishWithin outcome } }
      quaddie {
        trackName kind name rationale combos chance earlyLook finalAt outcome
        legs { legNo raceNumber jumpTime outcome runners { tabNumber horseName scratched won } }
      }
`;

/** The member's chat with the team; pass afterId to fetch only newer messages when polling. */
export const GET_MY_CHAT = gql`
  query MyChat($afterId: Int) {
    myChat(afterId: $afterId) {
      teamName
      status
      unreadCount
      messages {${CHAT_MESSAGE_FIELDS}      }
    }
  }
`;

export const GET_MY_CHAT_UNREAD = gql`
  query MyChatUnreadCount {
    myChatUnreadCount
  }
`;
